/** ULID（端末で作る ID。docs/offline-sync.md 3 章）。時刻 48bit＋乱数 80bit を Crockford の base32 で 26 文字 */
const ALPHABET = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";

export function encodeTime(ms: number): string {
  if (!Number.isFinite(ms) || ms < 0 || ms > 2 ** 48 - 1) throw new RangeError("ID の時刻が範囲外です");
  let out = "";
  let t = Math.floor(ms);
  for (let i = 0; i < 10; i++) {
    out = ALPHABET[t % 32] + out;
    t = Math.floor(t / 32);
  }
  return out;
}

export function encodeRandom(bytes: Uint8Array): string {
  // 80bit = 16 文字。1 バイトずつ下位 5bit を使う（偏りは 256/32 で無い）
  let out = "";
  for (let i = 0; i < 16; i++) out += ALPHABET[(bytes[i] ?? 0) % 32];
  return out;
}

let lastTime = -1;
let lastRandom: number[] = [];

/** 同じミリ秒の中でも並び順が作った順になるよう、乱数の部分を 1 ずつ増やす */
export function ulid(now: number = Date.now(), random: (n: number) => Uint8Array = randomBytes): string {
  if (now === lastTime) {
    for (let i = lastRandom.length - 1; i >= 0; i--) {
      const v = lastRandom[i]!;
      if (v < 31) {
        lastRandom[i] = v + 1;
        break;
      }
      lastRandom[i] = 0;
    }
  } else {
    lastTime = now;
    lastRandom = Array.from(random(16), (b) => b % 32);
  }
  return encodeTime(now) + lastRandom.map((v) => ALPHABET[v]).join("");
}

function randomBytes(n: number): Uint8Array {
  const b = new Uint8Array(n);
  crypto.getRandomValues(b);
  return b;
}

/** 端末の ID（ログインと同期で送る）。初回に作って保存する */
export function deviceId(storage: Pick<Storage, "getItem" | "setItem"> | null = safeLocalStorage()): string {
  const key = "el.deviceId";
  const saved = storage?.getItem(key);
  if (saved && /^[0-9A-Z]{26}$/.test(saved)) return saved;
  const id = ulid();
  storage?.setItem(key, id);
  return id;
}

function safeLocalStorage(): Storage | null {
  try {
    return typeof localStorage === "undefined" ? null : localStorage;
  } catch {
    return null;
  }
}
